'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { SEO } from '@/components/seo/seo';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <>
      <SEO
        title="Something went wrong"
        description="An unexpected error occurred. Please try again later."
        noIndex
      />
      <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4 text-center">
        <div className="max-w-2xl mx-auto space-y-6">
          <h1 className="text-6xl font-bold text-destructive">500</h1>
          <h2 className="text-3xl font-semibold">Something went wrong</h2>
          <p className="text-muted-foreground">
            An unexpected error occurred. Please try again later.
          </p>
          <div className="flex gap-4 justify-center pt-8">
            <Button onClick={() => reset()} variant="outline">
              Try again
            </Button>
            <Button asChild>
              <Link href="/">Back to Home</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
